import React from "react";
import "./Pedagogy.css";

function LearningPedagogy() {
  return (
    <>
      <div className="PedagogyInnerContainer">
        <h2>The Learning Pedagogy</h2>
        <div className="imageContentWrapper">
          <img
            src="images/Home/LearningPedagogyNew.png"
            className="pedagogyImage"
          />
          {/* <div className="outerBox box1">
            <p>
              <strong>Digittized Content:</strong> Creating reusable content
              through LMS, scalable Cloud labs, and Ecosystem partners/vendors
              to provide anytime-anywhere-any-size learning to the lerners.
            </p>
          </div>
          <div className="outerBox box2">
            <p>
              <strong>Learning Analytics:</strong> Continually remodeling and
              creating learning design and delivery basis data collection and
              analysis.
            </p>
          </div>
          <div className="outerBox box3">
            <p>
              <strong>Learning Methods:</strong> Plugging in different modes of
              learning like classroom (conceptual +hands-on), virtual or online
              with SME interventions, project relevant case studies,
              mini-projects, and knowledge checks, thoughtfully weaved into the
              curriculum to provide a holistic learning experience learning
            </p>
          </div>
          <div className="outerBox box4">
            <p>
              <strong>Evaluation Techniques:</strong> Evaluating learners
              through assessments, and project-specific case studies to analyze
              the effectiveness of the learner
            </p>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default LearningPedagogy;
